// extracted by mini-css-extract-plugin
export default {"statueContainer":"AboutGame_statueContainer__90Yz3","statueContent":"AboutGame_statueContent__RWba0","description":"AboutGame_description__BYe8p"};